import axios from "axios";

const $host = axios.create({
	baseURL: process.env.REACT_APP_BASE_URL,
	timeout: 20000,
	headers: {
		'Content-Type': 'application/json',
	},
});

const API = {
	get: async (url, config) => {
		try {
			const request = await $host.get(url, config);
			return { data: request.data, headers: request.headers, status: request.status };
		} catch (error) {
			console.error({error});
			throw error.response;
		}
	},
	post: async (url, body, config) => {
		try {
			const request = await $host.post(url, body, config);
			return { data: request.data, headers: request.headers, status: request.status };
		} catch (error) {
			console.error({error});
			throw error.response;
		}
	},
	put: async (url, config) => {
		try {
			const request = await $host.put(url, config);
			return { data: request.data, headers: request.headers, status: request.status };
		} catch (error) {
			console.error(error);
			throw error.response;
		}
	},
	delete: async (url, config) => {
		try {
			const request = await $host.delete(url, { data: config });
			return { data: request.data, headers: request.headers, status: request.status };
		} catch (error) {
			console.error(error);
			throw error.response;
		}
	},
	setKey: key => {
		$host.defaults.headers.common.Authorization = 'Bearer ' + key;
	},
	getKey: () => {
		return $host.defaults.headers.common.Authorization.split(' ')[1];
	},
};

export {
	API,
};
